import React, {useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from "axios";
import { getSaldo_u } from "../../../functions/tablice";
import { zl } from '../../../functions/utilities.js';
import { dataFormat2 } from '../../../functions/dataFormat.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { 
    fetchWspolnoty, 
    fetchMieszkancy, 
    fetchMieszkancyAll,
    fetchPrzelewy, 
    fetchLokale, 
    fetchUlice, 
    fetchStawki, 
    fetchStawkiJednorazowe,
    fetchStawkiJednorazoweInd,
    fetchGrupy, 
    fetchUdzialyKonta,
    fetchUsers,
    fetchPlanowaneZuzycie,
    fetchUdzialyKontaAkt
  } from '../../../Redux/Actions.js'; 

const przeksiegowaniaForm = (props) => {

    const { udzialyKontaAkt_u, tablicaCzynsze, tablicaPrzelewy, wybranaWspolnotaId, setWybranyMieszkaniecId, wybranyMieszkaniecId, kontoGlowneSaldo_w} = props;
    
    const [udzialZ, setUdzialZ] = useState([]);
    const [udzialNa, setUdzialNa] = useState([]);
    const [saldo_u, setSaldo_u] = useState([]);
    const [czynszeWspolnota, setCzynszeWpolnota] = useState([]);
    const [przelewyWspolnota, setPrzelewyWspolnota] = useState([]);
    const [kwota, setKwota] = useState(0);
    const [opis, setOpis] = useState("");
    const [dataOperacji, setDataOperacji] = useState(dataFormat2(new Date()));

    const handleZ = e => {
        const id = e.target.value;
        if (id == -99) {
            setUdzialZ({grupa_numer: 0});
        } else {
            setUdzialZ( udzialyKontaAkt_u?.find( u => u.id == e.target.value))
        }
    }

    const handleNa = e => setUdzialNa( udzialyKontaAkt_u?.find( u => u.id == e.target.value));
    
    const dispatch = useDispatch();

    const udzialyZ = udzialyKontaAkt_u?.map( (u, i) => (
        <option 
            key={i} 
            value={u.id}
        >
            {`Grupa numer ${u.grupa_numer} (saldo: ${zl(saldo_u?.find(s=>s?.id == u.id)?.saldo)})`}
        </option>
    ));

    const zKontaGlownego = () => {
        if (kontoGlowneSaldo_w !== 0 ) {
            return (
                <option
                    key={-99}
                    value={-99}
                >
                    {`Konto wspólnoty (saldo: ${zl(kontoGlowneSaldo_w)})`}
                </option>
            )
        }
    }   

    const udzialyNa = udzialyKontaAkt_u?.map( (u, i) => (
        <option 
            key={i} 
            value={u.id}
        >
            {`Grupa numer ${u.grupa_numer} (saldo: ${zl(saldo_u?.find(s=>s?.id == u.id)?.saldo)})`}
        </option>
    ));

    useEffect( ( ) => {
        setSaldo_u( getSaldo_u( przelewyWspolnota, czynszeWspolnota, udzialyKontaAkt_u ) )
    },[przelewyWspolnota, czynszeWspolnota, udzialyKontaAkt_u])

    useEffect( ()  => {
        setCzynszeWpolnota( tablicaCzynsze?.find( t => t?.id_wspolnoty == wybranaWspolnotaId)?.grupy );
        setPrzelewyWspolnota( tablicaPrzelewy?.find( t => t?.id_wspolnoty == wybranaWspolnotaId)?.grupy )
    },[tablicaCzynsze, tablicaPrzelewy, wybranaWspolnotaId])

    const handleKwotaChange = e => setKwota( e.target.value );
    const handleOpisChange = e => setOpis( e.target.value);

    useEffect( () => setKwota(0), [udzialZ, wybranyMieszkaniecId]);

    const handleSubmit = () => {
        
        if (kwota > 0) {
            const czyKontoGLowne = udzialZ.grupa_numer == 0 ? true : false;
            const objZ = {
                kwota: kwota * -1,
                id_user: wybranyMieszkaniecId,
                grupa_numer: udzialZ.grupa_numer,
                id_wspolnoty: wybranaWspolnotaId,
                operacja: "przeksięgowanie z",
                przeksiegowanie_z: udzialZ.grupa_numer,
                przeksiegowanie_na: udzialNa.grupa_numer,
                nadawca_konto: czyKontoGLowne ? "Konto główne wspólnoty" : udzialZ?.konto_bankowe,
                odbiorca_konto: udzialNa?.konto_bankowe,
                nazwa_transakcji: opis,
                data_operacji: dataOperacji
            }
            const objNa = {
                kwota: kwota,
                id_user: wybranyMieszkaniecId,
                grupa_numer: udzialNa.grupa_numer,
                id_wspolnoty: wybranaWspolnotaId,
                operacja: "przeksięgowanie na",
                przeksiegowanie_z: udzialZ.grupa_numer,
                przeksiegowanie_na: udzialNa.grupa_numer,
                nadawca_konto: czyKontoGLowne ? "Konto główne wspólnoty" : udzialZ?.konto_bankowe,
                odbiorca_konto: udzialNa?.konto_bankowe,
                nazwa_transakcji: opis,
                data_operacji: dataOperacji
            }
            send(objZ);
            send(objNa);
            setKwota(0);
            setOpis("");
            setUdzialZ([]);
            setUdzialNa([]);
            setWybranyMieszkaniecId(0);
        }
    }

    async function send(obj) {
        try {
            await axios.post('/api/przelewy/przeksieguj', obj)
                .then( response => {
                    dispatch(fetchWspolnoty()); 
                    dispatch(fetchMieszkancy()); 
                    dispatch(fetchMieszkancyAll());
                    dispatch(fetchUsers());
                    dispatch(fetchPrzelewy()); 
                    dispatch(fetchLokale()); 
                    dispatch(fetchUlice()); 
                    dispatch(fetchStawki()); 
                    dispatch(fetchStawkiJednorazowe());
                    dispatch(fetchStawkiJednorazoweInd());
                    dispatch(fetchGrupy()); 
                    dispatch(fetchUdzialyKonta());
                    dispatch(fetchUdzialyKontaAkt());
                    dispatch(fetchPlanowaneZuzycie());
                });
        } catch (error) {
            console.error(`Error for item:`, error);
        }            
    }     

    const handleDataOperacji = e => setDataOperacji( e.target.value);

    return (
        <div className='przeksiegowaniaForm' >
            <div className='listy'>
                <div className='zNa'>
                    <span>
                        Przeksięgowanie z:
                    </span>
                    <select 
                        value={udzialZ?.id}
                        onChange={handleZ}
                    >
                        <option
                            key={0}
                            value={0}
                        >
                            (wybierz)
                        </option>
                        {udzialyZ}
                        {zKontaGlownego()}
                    </select>
                </div>
                <div className='zNa'>
                    <span>
                        Przeksięgowanie na:
                    </span>
                    <select 
                        value={udzialNa?.id}
                        onChange={handleNa}
                    >
                        <option
                            key={0}
                            value={0}
                        >
                            (wybierz)
                        </option>
                        {udzialyNa}
                    </select>
                </div>
            </div>
            <div className='form'>
                <div>
                    <span>
                        Opis:
                    </span>
                    <input
                        type="text"
                        className='opis'
                        value={opis}
                        onChange={handleOpisChange}
                    />
                </div>
                <div>
                    <span>
                        Kwota:
                    </span>
                    <input 
                        type="number"
                        value={kwota}
                        onChange={handleKwotaChange}
                    />
                </div>
            </div>
            <div className='form'>
                <input 
                    type="date"
                    value={dataOperacji}
                    onChange={handleDataOperacji}
                />
                <button
                    onClick={handleSubmit}
                    className='pointer'
                >
                    <FontAwesomeIcon icon={faPlay} />                    
                </button>
            </div>
        </div>
    )
}

export default przeksiegowaniaForm;